import {getRequest, URL_SERVER} from './../requests'


export async function getCampaigns(token){
    try {
        return await getRequest(URL_SERVER + '/campaigns', token)
    } catch (error) {
        console.error(error);
    }
}